module.exports = __webpack_public_path__ + "static/media/studio419.b1efd39b.ico";